import { usePage } from '~/common/hooks/usePage'
import { FormNavMenu } from '../form-settings/FormNavMenu'
import { TableNav } from '../tables/TableNav'

export function TitleBarNav() {
  const { objectId, pageType } = usePage()

  if (objectId && pageType === 'formSettings') {
    return <FormNavMenu formId={objectId} />
  }
  if (objectId && pageType === 'table') {
    return <TableNav tableId={objectId} />
  }
  return null
}
